import { useState, useEffect } from 'react';
import { Bell, Volume2 } from 'lucide-react';

export default function EnableNotificationsButton() {
  const [audioEnabled, setAudioEnabled] = useState(false);
  const [notificationPermission, setNotificationPermission] = useState<NotificationPermission>('default');

  useEffect(() => {
    // Verificar permissão de notificação
    if ('Notification' in window) {
      setNotificationPermission(Notification.permission);
    }

    // Verificar se áudio já foi habilitado
    const enabled = localStorage.getItem('audioNotificationsEnabled') === 'true';
    setAudioEnabled(enabled);
  }, []);

  const enableAudio = async () => {
    try {
      // Tocar um som silencioso para desbloquear autoplay
      const audio = new Audio('/notification.mp3');
      audio.volume = 0.01;
      await audio.play();
      audio.pause();
      
      localStorage.setItem('audioNotificationsEnabled', 'true');
      setAudioEnabled(true);
      
      console.log('✅ Notificações sonoras ativadas!');
    } catch (error) {
      console.error('❌ Erro ao ativar áudio:', error);
    }
  };

  const requestNotificationPermission = async () => {
    console.log('🔔 Botão clicado!');
    console.log('   Permissão atual:', Notification.permission);
    console.log('   Áudio habilitado:', audioEnabled);
    
    if ('Notification' in window && Notification.permission === 'default') {
      console.log('📢 Solicitando permissão de notificação...');
      const permission = await Notification.requestPermission();
      console.log('   Permissão concedida:', permission);
      setNotificationPermission(permission);
      
      if (permission === 'granted') {
        await enableAudio();
      }
    } else if (Notification.permission === 'granted') {
      console.log('🔊 Permissão já concedida, ativando áudio...');
      await enableAudio();
    } else {
      console.log('⚠️ Permissão de notificação negada');
      alert('Por favor, permita notificações nas configurações do navegador');
    }
  };

  if (audioEnabled && notificationPermission === 'granted') {
    return (
      <div className="flex items-center gap-2 text-sm text-green-600">
        <Volume2 className="w-4 h-4" />
        <span>Notificações ativas</span>
      </div>
    );
  }

  return (
    <button
      onClick={requestNotificationPermission}
      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
    >
      {notificationPermission === 'granted' ? (
        <>
          <Volume2 className="w-4 h-4" />
          <span>Ativar Som</span>
        </>
      ) : (
        <>
          <Bell className="w-4 h-4" />
          <span>Ativar Notificações</span>
        </>
      )}
    </button>
  );
}
